import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import styles from "./Placeholder.module.css";

export default function NotFoundPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <div className={styles.page}>
      <div className={styles.icon}>🔍</div>
      <h2 className={styles.title}>{t("error.notFoundTitle")}</h2>
      <p className={styles.note}>{t("error.notFoundBody")}</p>
      <div className={styles.actions}>
        <button className={styles.btn} onClick={() => navigate(-1)}>← {t("action.back")}</button>
        <button className={styles.btnPrimary} onClick={() => navigate("/")}>{t("action.goHome")}</button>
      </div>
    </div>
  );
}
